// extracted by mini-css-extract-plugin
module.exports = {"container":"vimvKrj","modal":"_1O6dGn8","fade":"_1ry-CZP","fadeIn":"iPaD8Gc","content":"_27-nvPf"};